import React, { useState, useRef, useEffect } from "react";
import {
  TextField,
  IconButton,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import MicIcon from "@mui/icons-material/Mic";
import EmailVerified from "../../Assets/img/Email-Verified.png";
import axios from 'axios';
import { useQuantityContext } from "../QuantityContext";

const ActiveStep3 = ({
  setFormData,
  activeStep,
  setActiveStep,
  experience,
  education,
  onVerificationComplete,  // REQUIRED: Callback to parent
  verificationStatus,        // REQUIRED: Current verification status
  isSignup
}) => {
  const { openSnackbar, handleFailure, handleInfo } = useQuantityContext();

  const apiKey = process.env.REACT_APP_API_KEY
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json',
  };

  const [DisplayFirstPage, setDisplayFirstPage] = useState(true);
  const [DisplaySecondPage, setDisplaySecondPage] = useState(false);
  const [emailValidate, setEmailValidate] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [personalEmail, setPersonalEmail] = useState({
    email: ''
  });
  const [profEmail, setProfEmail] = useState({
    email: null
  });
  const [errorMessage, setErrorMessage] = useState("");
  const otpInputsRef = useRef([]);
  const [otpValues, setOtpValues] = useState(['', '', '', '']);
  const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const [minutes, setMinutes] = useState(3);
  const [seconds, setSeconds] = useState(0);

  const resendOTP = async () => {
    try {
      if (personalEmail.email.trim() !== "" && emailRegex.test(personalEmail.email.trim())) {
        openSnackbar("Sending OTP to your E-mail ID...", "info", 3000);
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/send-otp`, { email: personalEmail },
          { headers: headers }
        );

        if (response.status === 200) {
          setMinutes(0);
          setSeconds(180);
          setValidEmail(false);
          openSnackbar('OTP sent successfully to your E-mail ID.', "success", 8000);
          setFormData(prevFormData => ({
            ...prevFormData,
            personalEmail: personalEmail,
            professionalEmail: profEmail
          }));
        }
      } else {
        setEmailValidate(true);
        openSnackbar("E-mail ID empty or invalid.", "error");
      }
    } catch (error) {
      setEmailValidate(true);
      openSnackbar("Error sending OTP. Try again.", "error");
      console.error("Error sending message:", error);
    }
  };

  useEffect(() => {
    if (DisplaySecondPage) {
      const interval = setInterval(() => {
        if (minutes === 0 && seconds === 0) {
          setOtpValues(["", "", "", ""]);
          clearInterval(interval);
        } else {
          if (seconds > 0) {
            setSeconds(seconds - 1);
          } else {
            if (minutes > 0) {
              setMinutes(minutes - 1);
              setSeconds(59);
            }
          }
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [DisplaySecondPage, seconds, minutes]);

  const handleInput = (index) => (e) => {
    const value = e.target.value;
    const maxLength = parseInt(e.target.getAttribute("maxlength"));
    const nextInput = otpInputsRef.current[index + 1];

    setOtpValues(prevValues => {
      const newValues = [...prevValues];
      newValues[index] = value;
      return newValues;
    });

    if (value.length === maxLength && nextInput) {
      nextInput.focus();
    }
    setValidEmail(false);
  };

  const handleKeyDown = (index) => (e) => {
    if (e.key === 'Backspace') {
      if (otpValues[index] === '' && index > 0) {
        otpInputsRef.current[index - 1].focus();
        setOtpValues((prevValues) => {
          const newValues = [...prevValues];
          newValues[index - 1] = '';
          return newValues;
        });
      }
    }
  };

  // CRITICAL: This function verifies the email and updates parent state
  const handleVerifyEmail = async () => {
    if (personalEmail.email.trim() === "" && !emailRegex.test(personalEmail.email.trim())) {
      openSnackbar("Empty or Invalid E-mail ID. Try Again.", "error");
      return;
    }
    const otp = parseInt(otpValues.join(''));
    setValidEmail(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/onboard/verify-otp`,
        { email: personalEmail, otp: otp },
        { headers: headers }
      );

      if (response.status === 200) {
        setIsEmailVerified(true);
        setIsVerifiedDialogOpen(true);
        openSnackbar("Email verified successfully!", "success", 3000);

        // 🔥 CRITICAL: This updates the parent's verification status
        console.log("📧 Calling onVerificationComplete with true");
        if (onVerificationComplete) {
          onVerificationComplete(true);
        }

        setFormData(prevFormData => ({
          ...prevFormData,
          personalEmail: personalEmail,
          professionalEmail: profEmail,
          emailVerified: true
        }));
      }
    } catch (error) {
      setValidEmail(false);
      if (error.response) {
        const { message } = error.response.data;
        if (message === "Incorrect OTP") {
          console.log("Incorrect OTP Response:", error.response);
          openSnackbar("Incorrect OTP! Please Try Again.", "error");
          return;
        }
        if (message === "Invalid OTP") {
          console.log("Invalid OTP Response:", error.response);
          openSnackbar("Invalid OTP! Please Try Again.", "error");
          return;
        }
      } else {
        console.error('Error verifying email:', error);
        handleFailure('Error verifying email. Please try again later.');
      }
    }
  };

  const [ValidEmail, setValidEmail] = useState(false);

  const handlePersonalEmailChange = (e) => {
    if (isEmailVerified || verificationStatus?.emailVerified) return;
    setPersonalEmail({ ...personalEmail, email: e.target.value });
    setEmailValidate(false);
    setErrorMessage(false);
    setValidEmail(false);
  };

  const handleNext = async () => {
    try {
      if (personalEmail.email.trim() !== "" && emailRegex.test(personalEmail.email.trim())) {
        setIsVisible(true);
        openSnackbar("Sending OTP to E-mail ID...", "info", 3000);
        setValidEmail(true);
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/send-otp`, { email: personalEmail }, {
          headers: headers
        });
        console.log("validation", response);
        if (response.status === 200) {
          openSnackbar('OTP sent successfully to the E-mail ID.', "success", 8000);
          setValidEmail(true);
          setFormData(prevFormData => ({
            ...prevFormData,
            personalEmail: personalEmail,
            professionalEmail: profEmail
          }));
          setTimeout(() => {
            setDisplaySecondPage(true);
            setDisplayFirstPage(false);
          }, 2000);
        }
        else if (response.status === 226) {
          openSnackbar("User already registered. Please Login.", "info", 8000);
          setValidEmail(false);
        }
        else if (response.status === 206) {
          openSnackbar("This Email Id is not allowed. Please contact Admin", "info", 8000);
          setValidEmail(false);
          return;
        }
      } else {
        setEmailValidate(true);
        openSnackbar("Empty or Invalid E-mail ID", "error");
        setValidEmail(false);
      }
    } catch (error) {
      setEmailValidate(true);
      setValidEmail(false);
      openSnackbar("Error saving E-mail ID. Try again later.", "error");
      console.error("Error sending message:", error);
      setErrorMessage("Please Enter Valid Email ID");
    }
  }

  const handleCloseVerifiedDialog = () => {
    setIsVerifiedDialogOpen(false);
  }

  const handleContinue2 = () => {
    setIsVerifiedDialogOpen(false);
    if (isSignup) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
    else {
      if (setActiveStep) {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }
  };

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
    }, 30000);
    return () => clearTimeout(timeout);
  }, []);

  const shouldBlink = seconds < 20 && minutes === 0 && seconds !== 0;
  const blinkClass = shouldBlink ? "otp-blinking" : "";

  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

  const handleGoBack = () => {
    if (activeStep === 3) {
      setActiveStep((prevActiveStep) => prevActiveStep - 2);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  return (
    <>
      {DisplayFirstPage && (
        <>
          <React.Fragment>
            <div className="page-title-wrapper">
              <h2 className="onboard-slide-title-2">Add Email Id</h2>
              <p className="page-subtitle" style={{
                fontSize: '16px',
                lineHeight: '1.6',
                color: '#475569',
                marginBottom: '8px'
              }}>
                Please add your personal email address. We'll send a verification OTP to this email.
              </p>
              <p className="page-subtitle" style={{
                fontSize: '14px',
                color: '#64748b',
                marginBottom: '20px'
              }}>
                Make sure to use a valid email address that you have access to.
              </p>
            </div>
            <div>
              <TextField
                className="text-field-outline input-text"
                id="personalEmail"
                name="Personalmail"
                label="Personal Email ID"
                error={emailValidate}
                variant="outlined"
                value={personalEmail.email}
                onChange={handlePersonalEmailChange}
                fullWidth
                disabled={isEmailVerified || verificationStatus?.emailVerified}
                helperText={emailValidate ? "Please enter a valid email address" : ""}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: '#ffffff',
                    '& fieldset': {
                      borderColor: '#d0d5dd',
                    },
                    '&:hover fieldset': {
                      borderColor: '#0044C6',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: '#0044C6',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: '#344054',
                    '&.Mui-focused': {
                      color: '#0044C6',
                    },
                  },
                  '& .MuiInputBase-input': {
                    color: '#1a1a1a',
                  },
                }}
              />
              {errorMessage && <p className="error-message">{errorMessage}</p>}
              <div className="next-button-container gap-3 pt-2 pb-3">
                {/* {activeStep > 0 && (
                  <Button variant="outlined" className="skip-btn" onClick={handleGoBack}>
                    BACK
                  </Button>
                )} */}
                <Button
                  variant="contained"
                  className={`next-btn primary-contained`}
                  onClick={handleNext}
                  disabled={personalEmail.email === "" || ValidEmail || isEmailVerified || verificationStatus?.emailVerified}
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    backgroundColor: '#0044C6',
                    color: '#ffffff',
                    padding: '10px 40px',
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#003399',
                    },
                    '&.Mui-disabled': {
                      backgroundColor: '#e0e0e0',
                      color: '#999999'
                    }
                  }}>
                  Next
                </Button>
              </div>
            </div>
          </React.Fragment>
        </>
      )}

      {DisplaySecondPage && (
        <>
          <React.Fragment>
            <div className="page-title-wrapper">
              <h2 className="onboard-slide-title-2">Please Verify Your Email Address</h2>
              <p className="page-subtitle">Check your inbox for a verification email.</p>
            </div>

            {/* Email field - always visible but disabled when verified */}
            <div className="text-field-container">
              <TextField
                className="text-field-outline input-text"
                id="personalEmail"
                name="personalEmail"
                label="Personal Email ID"
                variant="outlined"
                value={personalEmail.email}
                onChange={handlePersonalEmailChange}
                disabled={isEmailVerified || verificationStatus?.emailVerified}
                InputLabelProps={{}}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton aria-label="voice input">
                        <MicIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '8px',
                    backgroundColor: (isEmailVerified || verificationStatus?.emailVerified) ? '#f5f5f5' : '#ffffff',
                    '& fieldset': {
                      borderColor: (isEmailVerified || verificationStatus?.emailVerified) ? '#4caf50' : '#d0d5dd',
                    },
                    '&:hover fieldset': {
                      borderColor: (isEmailVerified || verificationStatus?.emailVerified) ? '#4caf50' : '#0044C6',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: (isEmailVerified || verificationStatus?.emailVerified) ? '#4caf50' : '#0044C6',
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: (isEmailVerified || verificationStatus?.emailVerified) ? '#4caf50' : '#344054',
                    '&.Mui-focused': {
                      color: (isEmailVerified || verificationStatus?.emailVerified) ? '#4caf50' : '#0044C6',
                    },
                  },
                  '& .MuiInputBase-input': {
                    color: '#1a1a1a',
                  },
                }}
              />
            </div>

            {/* Show verification status and verified badge */}
            {(isEmailVerified || verificationStatus?.emailVerified) ? (
              <div style={{
                backgroundColor: '#e8f5e9',
                padding: '12px 16px',
                borderRadius: '8px',
                marginTop: '12px',
                marginBottom: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                border: '1px solid #4caf50'
              }}>
                <span style={{ color: '#2e7d32', fontSize: '20px', fontWeight: 'bold' }}>✓</span>
                <span style={{ color: '#1b5e20', fontSize: '15px', fontWeight: 600 }}>
                  Email Verified Successfully!
                </span>
              </div>
            ) : (
              <>
                {/* OTP Inputs - only show if not verified */}
                <div className="otp-input-wrapper">
                  {[1, 2, 3, 4].map((_, index) => (
                    <input
                      key={index}
                      type="text"
                      className="otp-input"
                      maxLength="1"
                      id={`otp${index + 1}`}
                      ref={(el) => (otpInputsRef.current[index] = el)}
                      value={otpValues[index]}
                      onChange={handleInput(index)}
                      disabled={minutes === 0 && seconds === 0 || isEmailVerified || verificationStatus?.emailVerified}
                      onKeyDown={handleKeyDown(index)}
                      autoFocus={index === 0}
                    />
                  ))}
                </div>

                <div className="justify-content-space-bw-login mt-20">
                  <div className="resent-otp">
                    Remaining Time: {" "}
                    <span className={`time-unit ${blinkClass}`}>{formattedMinutes}</span>:
                    <span className={`time-unit ${blinkClass}`}>{formattedSeconds}</span>
                  </div>

                  <div className="next-button-container gap-3 pt-2 pb-3">
                    {activeStep > 0 && (
                      <Button
                        variant="contained"
                        className={`next-btn primary-contained`}
                        onClick={handleVerifyEmail}
                        disabled={otpValues.some((value) => !value) || ValidEmail || isEmailVerified || verificationStatus?.emailVerified}
                        sx={{
                          textTransform: 'uppercase',
                          fontWeight: 600,
                          backgroundColor: '#0044C6',
                          color: '#ffffff',
                          padding: '10px 40px',
                          borderRadius: '8px',
                          '&:hover': {
                            backgroundColor: '#003399',
                          },
                          '&.Mui-disabled': {
                            backgroundColor: '#e0e0e0',
                            color: '#999999'
                          }
                        }}>
                        Verify
                      </Button>
                    )}
                  </div>
                </div>
                <div className="resent-otp-design mt-20">
                  Didn't get the code? <Button sx={{ color: "#0044C6" }} onClick={resendOTP}>RESEND</Button>
                </div>
              </>
            )}

            {/* Continue button - always shown when verified */}
            {(isEmailVerified || verificationStatus?.emailVerified) && (
              <div className="next-button-container gap-3 pt-2 pb-3" style={{ marginTop: '20px' }}>
                <Button
                  variant="contained"
                  className={`next-btn primary-contained`}
                  onClick={handleContinue2}
                  sx={{
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    backgroundColor: '#0044C6',
                    color: '#ffffff',
                    padding: '10px 40px',
                    borderRadius: '8px',
                    '&:hover': {
                      backgroundColor: '#003399',
                    }
                  }}>
                  Continue
                </Button>
              </div>
            )}

            {/* Dialog for email verification */}
            <Dialog
              open={isVerifiedDialogOpen}
              onClose={handleCloseVerifiedDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent className="dialogContainer email-dialog">
                <img
                  src={EmailVerified}
                  alt="Verification"
                  className="dialogImage"
                />
                <DialogTitle id="alert-dialog-title">Email Verified</DialogTitle>
                <DialogContentText className="dialogText">
                  Your email ID has been successfully verified.
                </DialogContentText>
                <Button
                  onClick={handleContinue2}
                  variant="contained"
                  className="continueButton primary-button"
                  sx={{
                    backgroundColor: '#0044C6',
                    color: '#ffffff',
                    '&:hover': {
                      backgroundColor: '#003399',
                    }
                  }}
                >
                  Continue
                </Button>
              </DialogContent>
            </Dialog>
          </React.Fragment>
        </>
      )}
    </>
  )
}

export default ActiveStep3;




// import React, { useState, useRef, useEffect } from "react";
// import {
//   TextField,
//   IconButton,
//   InputAdornment,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   // DialogActions,
//   Button,
// } from "@mui/material";
// import MicIcon from "@mui/icons-material/Mic";
// import EmailVerified from "../../Assets/img/Email-Verified.png";
// import axios from 'axios'; // for sending data to Backend
// // import InfoToast from "../Utilities/InfoToast";
// import { useQuantityContext } from "../QuantityContext";
// // import { act } from "react";


// const ActiveStep3 = ({ setFormData, activeStep, setActiveStep, experience, education }) => {
//   const { openSnackbar, handleFailure, handleInfo, } = useQuantityContext();

//   console.log("Experience", experience, "education", education);

//   const apiKey = process.env.REACT_APP_API_KEY
//   const headers = {
//     'x-api-key': apiKey,
//     'Content-Type': 'application/json',
//     // "ngrok-skip-browser-warning": "69420"
//   };

//   console.log("educationeducation", education, "experienceexperience", experience);
//   const [DisplayFirstPage, setDisplayFirstPage] = useState(true);
//   const [DisplaySecondPage, setDisplaySecondPage] = useState(false);
//   const [emailValidate, setEmailValidate] = useState(false);
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//   const [personalEmail, setPersonalEmail] = useState({
//     email: ''
//   });
//   const [profEmail, setProfEmail] = useState({
//     email: null
//   });
//   const [errorMessage, setErrorMessage] = useState("");
//   const otpInputsRef = useRef([]);
//   const [otpValues, setOtpValues] = useState(['', '', '', '']);
//   const [isVerifiedDialogOpen, setIsVerifiedDialogOpen] = useState(false);
//   // const [ProfessionalEmailVerify, setProfessionalEmailVerify] = useState(false)

//   const [minutes, setMinutes] = useState(3);
//   const [seconds, setSeconds] = useState(0); // Change initial seconds value to 0

//   const resendOTP = async () => {
//     try {
//       if (personalEmail.email.trim() !== "" && emailRegex.test(personalEmail.email.trim())) {
//         // console.log(personalEmail + "\t" + profEmail);
//         // setIsVisible(true);
//         openSnackbar("Sending OTP to your E-mail ID...", "info", 3000);
//         const response = await axios.post(
//           `${process.env.REACT_APP_BACKEND_URL}/onboard/send-otp`, { email: personalEmail },
//           { headers: headers }
//         );

//         if (response.status === 200) {
//           setMinutes(0);
//           setSeconds(180);
//           setValidEmail(false);
//           openSnackbar('OTP sent successfully to your E-mail ID.', "success", 8000);
//           setFormData(prevFormData => ({
//             ...prevFormData,
//             personalEmail: personalEmail,
//             professionalEmail: profEmail
//           }));
//         }
//       } else {
//         setEmailValidate(true);
//         // setErrorMessage("Please Enter Email ID.");
//         openSnackbar("E-mail ID empty or invalid.", "error");
//       }
//     } catch (error) {
//       setEmailValidate(true);
//       openSnackbar("Error sending OTP. Try again.", "error");
//       console.error("Error sending message:", error);
//       // setErrorMessage("Please Enter Valid Email ID");
//     }
//   };

//   useEffect(() => {
//     if (DisplaySecondPage) {
//       // Start the timer only when DisplaySecondPage becomes true
//       const interval = setInterval(() => {
//         if (minutes === 0 && seconds === 0) {
//           setOtpValues(["", "", "", ""]);
//           clearInterval(interval);

//         } else {
//           // Decrease seconds if greater than 0
//           if (seconds > 0) {
//             setSeconds(seconds - 1);
//           } else {
//             if (minutes > 0) {
//               setMinutes(minutes - 1);
//               setSeconds(59); // Reset seconds to 59 when minutes decrease
//             }
//           }
//         }
//       }, 1000);

//       return () => {
//         clearInterval(interval);
//       };
//     }
//   }, [DisplaySecondPage, seconds, minutes]);

//   const handleInput = (index) => (e) => {
//     const value = e.target.value;
//     const maxLength = parseInt(e.target.getAttribute("maxlength"));
//     const nextInput = otpInputsRef.current[index + 1];

//     // Update the OTP values in the state array
//     setOtpValues(prevValues => {
//       const newValues = [...prevValues];
//       newValues[index] = value;
//       return newValues;
//     });

//     if (value.length === maxLength && nextInput) {
//       nextInput.focus();
//     }
//     setValidEmail(false);
//   };

//   const handleKeyDown = (index) => (e) => {
//     if (e.key === 'Backspace') {
//       if (otpValues[index] === '' && index > 0) {
//         otpInputsRef.current[index - 1].focus();
//         setOtpValues((prevValues) => {
//           const newValues = [...prevValues];
//           newValues[index - 1] = '';
//           return newValues;
//         });
//       }
//     }
//   };

//   const handleVerifyEmail = async () => {
//     if (personalEmail.email.trim() === "" && !emailRegex.test(personalEmail.email.trim())) {
//       openSnackbar("Empty or Invalid E-mail ID. Try Again.", "error");
//       return;
//     }
//     const otp = parseInt(otpValues.join('')); // Concatenate OTP values and convert to number
//     setValidEmail(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_BACKEND_URL}/onboard/verify-otp`,
//         { email: personalEmail, otp: otp },
//         { headers: headers }
//       );

//       setIsVerifiedDialogOpen(true); // Open dialog on successful verification
//     } catch (error) {
//       setValidEmail(false);
//       if (error.response) {
//         const { message } = error.response.data;
//         if (message === "Incorrect OTP") {
//           console.log("Incorrect OTP Response:", error.response);
//           openSnackbar("Incorrect OTP! Please Try Again.", "error");
//           return;
//         }
//         if (message === "Invalid OTP") {
//           console.log("Invalid OTP Response:", error.response);
//           openSnackbar("Invalid OTP! Please Try Again.", "error");
//           return;
//         }
//       } else {
//         console.error('Error verifying email:', error);
//         handleFailure('Error verifying email. Please try again later.');
//       }
//     }
//   };


//   // const handleProfEmailChange = (e) => {
//   //   setProfEmail({...profEmail, email: e.target.value});
//   //   setProfessionalEmailVerify(false);
//   // };
//   const [ValidEmail, setValidEmail] = useState(false);

//   const handlePersonalEmailChange = (e) => {
//     setPersonalEmail({ ...personalEmail, email: e.target.value });
//     setEmailValidate(false);
//     setErrorMessage(false);
//     setValidEmail(false);
//   };

//   console.log("activeStep activeStep", activeStep);
//   const handleNext = async () => {
//     try {
//       if (personalEmail.email.trim() !== "" && emailRegex.test(personalEmail.email.trim())) {
//         // console.log(personalEmail + "\t" + profEmail);
//         setIsVisible(true);
//         openSnackbar("Sending OTP to E-mail ID...", "info", 3000);
//         // await axios.post(`${process.env.REACT_APP_BACKEND_URL}/mail/send-otp`, personalEmail);
//         setValidEmail(true);
//         const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/onboard/send-otp`, { email: personalEmail }, {
//           headers: headers
//         });
//         console.log("validation", response);
//         if (response.status === 200) {

//           openSnackbar('OTP sent successfully to the E-mail ID.', "success", 8000);
//           setValidEmail(true);
//           setFormData(prevFormData => ({
//             ...prevFormData,
//             personalEmail: personalEmail,
//             professionalEmail: profEmail
//           }));
//           setTimeout(() => {
//             setDisplaySecondPage(true);
//             setDisplayFirstPage(false);
//           }, 2000);
//           if (typeof setActiveStep === 'function') {
//             setActiveStep(); // This will trigger scroll to phone section
//           }
//         }
//         else if (response.status === 226) {
//           openSnackbar("User already registered. Please Login.", "info", 8000);
//           setValidEmail(false);

//         }

//         else if (response.status === 206) {
//           openSnackbar("This Email Id is not allowed. Please contact Admin", "info", 8000);
//           setValidEmail(false);
//           return;
//         }
//       } else {
//         setEmailValidate(true);
//         openSnackbar("Empty or Invalid E-mail ID", "error");
//         setValidEmail(false);
//       }
//     } catch (error) {
//       setEmailValidate(true);
//       setValidEmail(false);
//       openSnackbar("Error saving E-mail ID. Try again later.", "error");
//       console.error("Error sending message:", error);
//       setErrorMessage("Please Enter Valid Email ID");
//     }

//     // if (activeStep !== 1 && activeStep !== 2) {
//     //   // console.log("This is Running")
//     //   setActiveStep((prevActiveStep) => prevActiveStep + 1);
//     // }
//   }

//   const handleCloseVerifiedDialog = () => {
//     setIsVerifiedDialogOpen(false);
//   }
//   const handleContinue2 = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   };

//   const [isVisible, setIsVisible] = useState(false);

//   // Hide the component after 5 seconds
//   useEffect(() => {
//     const timeout = setTimeout(() => {
//       setIsVisible(false);
//     }, 30000);

//     // Clear the timeout when the component unmounts
//     return () => clearTimeout(timeout);
//   }, []);

//   // Determine if the Remaining Time should blink
//   const shouldBlink = seconds < 20 && minutes === 0 && seconds !== 0;
//   const blinkClass = shouldBlink ? "otp-blinking" : "";

//   // Format the time with leading zero if necessary
//   const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
//   const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

//   const handleGoBack = () => {
//     if (activeStep === 3) {
//       setActiveStep((prevActiveStep) => prevActiveStep - 2);
//     } else {
//       setActiveStep((prevActiveStep) => prevActiveStep - 1);
//     }
//   };

//   return (
//     <>
//       {DisplayFirstPage && (
//         <>
//           <React.Fragment>
//             <div className="page-title-wrapper">
//               <h2 className="onboard-slide-title-2">Add Email Id</h2>
//               <p className="page-subtitle">An OTP will be sent for verification to the entered E-mail ID</p>
//             </div>
//             <div>
//               <TextField
//                 className="text-field-outline input-text"
//                 id="personalEmail"
//                 name="Personalmail"
//                 label="Personal Email ID"
//                 error={emailValidate}
//                 variant="outlined"
//                 value={personalEmail.email}
//                 onChange={handlePersonalEmailChange}
//                 fullWidth
//               />
//               {errorMessage && <p className="error-message">{errorMessage}</p>}
//               {/* <p className="para-text">Add your Professional Email Id (Optional)</p>
//             <TextField
//               className="text-field-outline input-text "
//               label="Email"
//               type="email"
//               name="professionalEmail"
//               value={profEmail.email}
//               error={ProfessionalEmailVerify}
//               variant="outlined"
//               onChange={handleProfEmailChange}
//               InputLabelProps={{}}
//               InputProps={{
//                 endAdornment: (
//                   <InputAdornment position="end">
//                     <IconButton aria-label="voice input">
//                       <MicIcon />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//               }}
//             /> */}
//               <div className="next-button-container gap-3 pt-2 pb-3">
//                 {activeStep > 0 && (
//                   <Button variant="outlined" className="skip-btn" onClick={handleGoBack}>
//                     BACK
//                   </Button>
//                 )}
//                 <Button
//                   variant="outlined"
//                   className={`next-btn primary-outlined`}
//                   onClick={handleNext}
//                   disabled={personalEmail.email === "" || ValidEmail}>
//                   Next
//                 </Button>
//               </div>
//             </div>

//             {/* {isVisible && (
//               <InfoToast destination="progress" />
//             )} */}
//           </React.Fragment>
//         </>
//       )}

//       {DisplaySecondPage && (
//         <>
//           <React.Fragment>
//             <div className="page-title-wrapper">
//               <h2 className="onboard-slide-title-2">Please Verify Your Email Address</h2>
//               <p className="page-subtitle">Check your inbox for a verification email.</p>
//             </div>
//             <div className="text-field-container">
//               <TextField
//                 className="text-field-outline input-text"
//                 id="personalEmail"
//                 name="personalEmail"
//                 label="Personal Email ID"
//                 variant="outlined"
//                 value={personalEmail.email}
//                 onChange={handlePersonalEmailChange}
//                 InputLabelProps={{}}
//                 InputProps={{
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton aria-label="voice input">
//                         <MicIcon />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 }}
//               />
//             </div>
//             {/* Display otp inputs */}
//             <div className="otp-input-wrapper">
//               {[1, 2, 3, 4].map((_, index) => (
//                 <input
//                   key={index}
//                   type="text" // Change type to "number" for numeric input
//                   className="otp-input"
//                   maxLength="1"
//                   id={`otp${index + 1}`}
//                   ref={(el) => (otpInputsRef.current[index] = el)}
//                   value={otpValues[index]} // Set value from state
//                   onChange={handleInput(index)}
//                   disabled={minutes === 0 && seconds === 0}
//                   onKeyDown={handleKeyDown(index)}
//                   autoFocus={index === 0}
//                 />
//               ))}
//             </div>
//             {/* Verify button */}

//             <div className="justify-content-space-bw-login mt-20">
//               <div className="resent-otp">
//                 Remaining Time: {" "}
//                 <span className={`time-unit ${blinkClass}`}>{formattedMinutes}</span>:
//                 <span className={`time-unit ${blinkClass}`}>{formattedSeconds}</span>
//               </div>

//               <div className="next-button-container gap-3 pt-2 pb-3">
//                 {activeStep > 0 && (
//                   <Button
//                     variant="outlined"
//                     className={`next-btn primary-outlined`}
//                     onClick={handleVerifyEmail}
//                     disabled={otpValues.some((value) => !value) || ValidEmail}>
//                     Next
//                   </Button>
//                 )}
//               </div>
//             </div>
//             <div className="resent-otp-design mt-20">
//               Didn't get the code? <Button sx={{ color: "#0044C6" }} onClick={resendOTP}>RESEND</Button>
//             </div>

//             {/* Dialog for email verification */}
//             <Dialog
//               open={isVerifiedDialogOpen}
//               onClose={handleCloseVerifiedDialog}
//               aria-labelledby="alert-dialog-title"
//               aria-describedby="alert-dialog-description"
//             >
//               <DialogContent className="dialogContainer email-dialog">
//                 <img
//                   src={EmailVerified}
//                   alt="Verification"
//                   className="dialogImage"
//                 // width={60}
//                 // height={60}
//                 />
//                 <DialogTitle id="alert-dialog-title">Email Verified</DialogTitle>
//                 <DialogContentText className="dialogText">
//                   Your email ID has been successfully verified.
//                 </DialogContentText>
//                 <Button
//                   onClick={handleContinue2}
//                   variant="contained"
//                   className="continueButton primary-button"
//                 >
//                   Continue
//                 </Button>
//               </DialogContent>
//             </Dialog>


//           </React.Fragment>
//         </>
//       )}

//     </>
//   )
// }

// export default ActiveStep3